var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltipOptions),expression:"tooltipOptions"}],staticClass:"discount-badge"},[_c('IconSvg',{staticClass:"discount-svg",attrs:{"filepath":"discount.svg"}}),_vm._v(" "),_c('span',{staticClass:"discount-value"},[_vm._v(_vm._s(_vm.discountText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }